<template>
  <Nav ref="nav" search="true" :agenciesForSearch="agencies" />
  <div class="page-top">
    <div class="page-top-content content-container">
      <h1>{{ agency ? agency.meta.friendlyName : '' }}</h1>
      <p>{{ agency ? agency.meta.uza_name : '' }}</p>
    </div>
  </div>
  <div id="agency" class="main content-container">
    <div v-if="agency">
      <h2>At a glance<span v-if="agency.overview.vrh.percentage_now > 0">: {{ monthName }}</span></h2>
      <div class="overview-section">
        <div class="service-overview">
          <div class="overview-content">
            <span class="overview-heading">Amount of transit service</span>
            <div class="overview-value-area">
              <span class="overview-value">{{ agency.overview.vrh.percentage_now  }}%</span>
              <p class="overview-desc">of transit vehicle service hours were operated</p>
            </div>
            <span class="overview-sub"><span v-if="agency.overview.vrh.percentage_now > 0">in {{ monthName }}&nbsp;</span>compared to before the pandemic</span>
          </div>
          <a class="agency-rank" href="#table-section" v-on:click="sortTable('service','descending'); resetTableFilters()">#{{ agency.meta.ranks.vrh[0] }} of {{ agency.meta.ranks.vrh[1] }} similarly-sized agencies</a>
        </div>
        <div class="ridership-overview">
          <div class="overview-content">
            <span class="overview-heading">Trips taken</span>
            <div class="overview-value-area">
              <span class="overview-value">{{ agency.overview.upt.percentage_now  }}%</span>
              <p class="overview-desc">of the trips taken by passengers were taken</p>
            </div>
            <span class="overview-sub"><span v-if="agency.overview.vrh.percentage_now > 0">in {{ monthName }}&nbsp;</span>compared to before the pandemic</span>
          </div>
          <a class="agency-rank" href="#table-section" v-on:click="sortTable('ridership','descending'); resetTableFilters()">#{{ agency.meta.ranks.upt[0] }} of {{ agency.meta.ranks.upt[1] }} similarly-sized agencies</a>
        </div>
      </div>
      <h2>Over time</h2>
      <ServiceRidershipChart :agency="agency" :baseMonths="['2020-01-01','2020-02-01']" />
      <div v-if="agency.meta.numberOfModes && agency.meta.numberOfModes > 1">
        <h2>Service restored by mode</h2>
        <ServiceByModeChart :agency="agency" :baseMonths="['2020-01-01','2020-02-01']" />
      </div>
      <TableSection ref="table" :stickTo="navComponent" :agencies="agencies" :selectedAgency="agency" id="table-section"> </TableSection>
    </div>
  </div>
  <Footer />
</template>

<script>
import GetURLParams from '../util/get-url-params.js'
import TransformMonthlyValues from '../util/transform-monthly-values.js'
import Nav from './Nav.vue'
import TableSection from './TableSection.vue'
import Footer from './Footer.vue'
import ServiceRidershipChart from './ServiceRidershipChart.vue'
import ServiceByModeChart from './ServiceByModeChart.vue'
import * as cacheValue from '../util/cache-value.js'

export default {
  name: 'AgencyDetailsPage',
  data() {
    return {
      agency: null,
      agencies: [],
      navComponent: null
    }
  },
  mounted() {
    fetch('https://ntd-monthly.storage.googleapis.com/agency-detail-' + GetURLParams()['id'] + '.json?v' + cacheValue())
      .then(response => response.json())
      .then(data => {
        this.agency = data
        this.agency.meta.friendlyName = this.agency.meta.dba ? this.agency.meta.dba : this.agency.meta.name

        var modes = {};
        this.agency.values.vrh.forEach((val) => {
          modes[TransformMonthlyValues.nameForMode(val.mode)] = true
        })
        this.agency.meta.numberOfModes = Object.entries(modes).length
      })

    fetch('https://ntd-monthly.storage.googleapis.com/agency-breakdown.json?v' + cacheValue())
      .then(response => response.json())
      .then(data => (this.agencies = data))

    this.navComponent = this.$refs.nav
  },
  computed: {
    maxMonthString(){
      if(!this.agency){ return '' }

      return TransformMonthlyValues.monthString(this.agency.meta.max_month)
    },
    monthName() {
      if(!this.agency){ return "" }
      var maxMonth;

      var date = (new Date(Date.parse(this.agency.meta.max_month)))
      date.setDate(date.getDate() + 10);
      return date.toLocaleDateString('en-EN',{ month: 'long', year: 'numeric' })
    }
  } ,
  methods: {
    sortTable(type,direction){
      this.$refs.table.sortBy(type,direction);
    },
    resetTableFilters(){
      this.$refs.table.resetFilters();
    }
  },
  components: {
    ServiceRidershipChart,
    ServiceByModeChart,
    Nav,
    TableSection,
    Footer
  }
}
</script>

<style>
.page-top {
  background: #2F4858;
  width: 100%;
  color: white;
  text-align: left;
  padding: 32px 0;
  border-top: 1px solid rgba(255,255,255,0.2);
}

.page-top .page-top-content {
  margin: 0 auto;
  display: block;
  width: 100%;
  max-width: 1000px;
  text-align: left;
}

.page-top h1 {
  margin-bottom: 0;
  margin-top: 0;
}

.page-top p {
  font-size: 16px;
}

.main {
  margin: 0 auto;
  width: 100%;
  max-width: 1000px;
  text-align: left;
}

h2 {
  margin-top: 48px;
  margin-bottom: 12px;
}

h2:first-of-type {
  margin-top: 36px;
}

.overview-section {
  width: 100%;
  margin-top: 20px;
}

.overview-section > div {
  width: calc(50% - 18px);
  background: #E6EBEE;
  box-sizing: border-box;
  display: inline-block;
  text-align: left;
  font-size: 14px;
  vertical-align: top;
}

.overview-section > div.service-overview {
  background: #F8EEF6;
}

.overview-section > div.ridership-overview {
  background: #E3F3F8;
}

@media(max-width: 816px){
  .overview-section > div {
    width: 100%;
    margin: 0;
    display: block;
    margin-bottom: 24px;
  }

  .overview-section > div:last-of-type {
    margin-bottom: 0;
  }
}

.overview-content {
  padding: 20px 24px;
}

a.agency-rank {
  display: block;
  line-height: 44px;
  height: 44px;
  border-top: 1px solid rgba(0,0,0,0.2);
  color: #326D93;
  font-weight: 700;
  text-decoration: underline;
  padding: 0 24px;
}

a.agency-rank:hover {
  color: #2F4858;
  background: rgba(0,0,0,0.025);
}

.service-overview a.agency-rank {
  border-color: #B692A8;
  color: #9C2697;
}

.ridership-overview a.agency-rank {
  border-color: #8FC6D8;
}

.overview-section > div:first-of-type {
  margin-right: 36px;
}

.overview-heading {
  font-size: 19px;
  font-weight: bold;
}

.overview-value-area {
  width: 100%;
  white-space: nowrap;
}

.overview-value {
  font-size: 44px;
  font-weight: bold;
  display: inline-block;
  width: auto;
  margin-right: 12px;
  font-family: mono45-headline, monospace;
}

.service-overview .overview-value {
  color: #9C2697;
}

.ridership-overview .overview-value {
  color: #047C97;
}

.overview-desc {
  display: inline-block;
  padding-left: 0;
  white-space: normal;
  max-width: 200px;
}

.overview-sub {
  width: 100%;
  display: block;
}
</style>
